// Generated by ReScript, PLEASE EDIT WITH CARE

import * as ApiBindJs from "./Api.bind.js";

function fetchPersonalLeaderboards3(prim) {
  return ApiBindJs.fetchPersonalLeaderboards3(prim);
}

function createBookmarkLeaderboards(prim0, prim1) {
  return ApiBindJs.createBookmarkLeaderboards(prim0, prim1);
}

export {
  fetchPersonalLeaderboards3 ,
  createBookmarkLeaderboards ,
  
}
/* ./Api.bind.js Not a pure module */
